module.exports = __webpack_public_path__ + "react/fonts/icomoon.46c41989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/utils/icomoon/icomoon.svg
// module id = 1899
// module chunks = 0